import type { AgendaDTO } from '@/features/api/extranet/dto/shared'

import { useFetch } from '@/features/fetch'
import { getToday } from '@/features/shared/tools'

export async function loadAgendas(init?: RequestInit): Promise<AgendaDTO[] | null> {
  if (!init) init = { sablier: true, dialogMode: 'silent' }

  const fetch = useFetch('base')
  const url = import.meta.env.VITE_RESSOURCES_STATIQUES + '/content/agendas.json'

  const response = await fetch(url, init)
  const result = (await response.json()) as AgendaDTO[]

  // On récupère les 3 prochaines dates après la date du jour et on trie en décroissant
  const sorted = result
    .filter((x) => new Date(x.date!) >= getToday())
    .sort((a, b) => new Date(a.date!).getTime() - new Date(b.date!).getTime())
    .slice(0, 3)
    .sort((a, b) => new Date(b.date!).getTime() - new Date(a.date!).getTime())

  return sorted
}
